import Button from "@/common/elements/Button";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledFlex, StyledGridCol, StyledGridRow } from "@/common/styles";
import AuditLogEntriesModal from "./AuditLogEntriesModal";
import { useEffect, useState } from "react";
import { BookingsSectionTitle } from "./styles";
import CommonDatePicker from "@/common/elements/DatePicker";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { Form } from "antd";
import { getRefListNameByID, isNonEmptyVariable } from "@/util/common_function";

const BookingAdministrativeInformation = ({
  showActionButton = true,
  showUser = true,
  showHeaderLabel = false,
  headerLabel = "",
  parentKey = "bookings",
  facilityLogDetail = null,
}) => {
  const ss = JSON.parse(sessionStorage.getItem("createNewBooking"));
  const [auditLogModal, setAuditLogModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [auditLogData, setAuditLogData] = useState([]);
  const [form] = Form.useForm();
  const { bookings } = useSelector((state) => state?.bookings);
  const { bookingsFieldsEnabled } = useSelector((state) => state?.bookings);
  const fullSearch = useSelector(state => state.fullSearch);

  useEffect(() => {
    if (isNonEmptyVariable(bookings)) {
      setAuditLogData(() => bookings?.systemAuditLog);
    }
  }, [bookings]);
  useEffect(() => {
    setIsDisabled(parentKey != "facilityLog" ? !bookingsFieldsEnabled : false);
  }, []);
  let formData = {};
  if (parentKey != "facilityLog") {
    formData = {
      BookingID: bookings?.bookingNumber || bookings?.visitorLogId,
      EnteredDate:
        bookings?.dateAdded && bookings?.timeAdded
          ? dayjs(`${bookings?.dateAdded} ${bookings?.timeAdded}`)
          : null,
      userID: bookings?.user,
    };
  } else {
    formData = {
      BookingID: facilityLogDetail?.commentLogID,
      EnteredDate:
        facilityLogDetail?.dateAdded && facilityLogDetail?.timeAdded
          ? dayjs(
              `${facilityLogDetail?.dateAdded} ${facilityLogDetail?.timeAdded}`
            )
          : null,
      userID: getRefListNameByID(
        "",
        facilityLogDetail?.creatorStaffID,
        true,
        false
      ),
    };
  }

  const handleAuditLogModal = () => {
    setAuditLogModal(!auditLogModal);
  };
  return (
    <>
      {showHeaderLabel && (
        <BookingsSectionTitle>
          <span>{headerLabel || "Administrative Information"}</span>
        </BookingsSectionTitle>
      )}

      <Form disabled={!fullSearch} form={form} initialValues={formData}>
        <StyledGridRow gutter={16}>
          <StyledGridCol span={4}>
            <FormItem name="BookingID" label="ID">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol span={6}>
            <FormItem name="EnteredDate" label="Date & Time Entered">
              <CommonDatePicker
                style={{
                  backgroundColor: isDisabled ? "#f5f5f5" : "",
                  color: isDisabled ? "#a0a0a0" : "",
                }}
                format="MM/DD/YYYY HH:mm"
                disabled={!fullSearch}
              />
            </FormItem>
          </StyledGridCol>

          {showUser && (
            <StyledGridCol span={6}>
              <FormItem name="userID" label="User">
                <TextField />
              </FormItem>
            </StyledGridCol>
          )}
          {((showActionButton &&
            isNonEmptyVariable(ss) &&
            !ss &&
            parentKey != "staff") ||
            parentKey == "facilityLog") && (
            <StyledGridCol>
              <StyledFlex
                justify="end"
                align="center"
                style={{ paddingTop: "28px" }}
              >
                <Button onClick={handleAuditLogModal} disabled={isDisabled}>
                  Audit Log
                </Button>
              </StyledFlex>
            </StyledGridCol>
          )}
        </StyledGridRow>
      </Form>

      <AuditLogEntriesModal
        auditLogData={auditLogData}
        show={auditLogModal}
        onHide={handleAuditLogModal}
      />
    </>
  );
};
export default BookingAdministrativeInformation;
